import React, { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';

// Shows a persistent banner when an admin has impersonated another user.
// Reads `localStorage.impersonatedBy` to detect impersonation and exposes
// an action to end the impersonation (calls `logout()` from AuthContext).
export default function ImpersonationBanner() {
  let auth = null;
  try {
    auth = useAuth();
  } catch (e) {
    // Not mounted inside AuthProvider (unit tests); render nothing.
    auth = null;
  }

  const [impersonatedBy, setImpersonatedBy] = useState(null);

  useEffect(() => {
    try {
      const id = localStorage.getItem('impersonatedBy');
      if (id) setImpersonatedBy(id);
    } catch (e) {
      // ignore storage errors
    }
  }, []);

  if (!impersonatedBy) return null;

  const user = auth?.user || null;
  const handleEnd = async () => {
    try {
      // AuthProvider.logout handles clearing the flag and redirecting
      if (auth?.logout) await auth.logout();
      else {
        try { localStorage.removeItem('impersonatedBy'); } catch (e) {}
        try { window.location.href = '/admin/users'; } catch (e) {}
      }
    } catch (e) {
      console.error('Error ending impersonation', e);
    }
  };

  // Display some user info if available; fall back to IDs.
  const viewedAs = user?.twitch_username || user?.username || user?.id || 'user';

  return (
    <div className="w-full bg-yellow-500 text-black border-b border-yellow-600">
      <div className="max-w-7xl mx-auto px-4 py-2 flex items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <strong className="font-medium">Impersonation active</strong>
          <span className="text-sm text-black/80">You are viewing the site as <span className="font-medium">{viewedAs}</span>.</span>
          <span className="text-sm text-black/70">Originally signed in as <span className="font-medium">{impersonatedBy}</span></span>
        </div>

        <div className="flex-shrink-0">
          <button
            onClick={handleEnd}
            className="inline-flex items-center gap-2 bg-black text-white px-3 py-1 rounded-md text-sm hover:opacity-90"
            aria-label="End impersonation and return to admin"
          >
            End impersonation
          </button>
        </div>
      </div>
    </div>
  );
}
